import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type';
import {
  GetAdjustersListQueryParamsType,
  GetAdjustersListQueryResponseType,
} from './getAdjustersListQuery.type';
import { fetchApi } from '@/config/axiosSetting';

type GetAdjustersListFunctionParamsType = GetAdjustersListQueryParamsType & {
  page?: number;
  page_size?: number;
};

export const getAdjustersListFunction = (
  params: GetAdjustersListFunctionParamsType,
): Promise<PaginationResponseType<GetAdjustersListQueryResponseType>> => {
  const { page, page_size, ...restParams } = params;
  return fetchApi.get('/survey/adjuster_ranks/', {
    params: {
      ...restParams,
      ...(page !== undefined ? { page } : {}),
      page_size: page_size ?? 10,
    },
  });
};
